// extracted by mini-css-extract-plugin
export var backLink = "BlogPost-module--backLink--39d7e";
export var backLinkWrapper = "BlogPost-module--backLinkWrapper--4e781";
export var blogPost = "BlogPost-module--blogPost--b5b47";
export var bottom = "BlogPost-module--bottom--4a551";
export var postText = "BlogPost-module--postText--f2fe7";
export var topHeader = "BlogPost-module--topHeader--6ced3";